var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Tooltip } from '@mui/material';
import { Building2, User } from 'lucide-react';
import { baseColors } from '../../../Themes/colors';
export var deriveCustomerType = function (program) {
    var value = String(program !== null && program !== void 0 ? program : '').trim().toLowerCase();
    if (!value || value === '--')
        return '';
    return value.includes('consumer') ? 'Consumer' : 'Commercial';
};
var CustomerTypeIcon = function (_a) {
    var type = _a.type;
    var iconProps = { size: 16, strokeWidth: 1.25, color: baseColors.greyPreset[30] };
    var icon = type === 'Commercial' ? React.createElement(Building2, __assign({}, iconProps)) : type === 'Consumer' ? React.createElement(User, __assign({}, iconProps)) : null;
    return (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-start', width: 16, flexShrink: 0 } }, icon && React.createElement(Tooltip, { title: type, arrow: true },
        React.createElement("span", { style: { display: 'inline-flex' } }, icon))));
};
export default CustomerTypeIcon;
